import script from "./PopupReviewMobileVideoControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupReviewMobileVideoControls.vue?vue&type=script&setup=true&lang=ts"

import "./PopupReviewMobileVideoControls.vue?vue&type=style&index=0&id=787523c8&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-787523c8"]])

export default __exports__